import { motion } from 'framer-motion';
import { Button } from '@mui/material';
import { AlertTriangle } from 'lucide-react';
import CredentialInstructions from './CredentialInstructions';

const ErrorContent = ({ redirectUserToApp }) => {
  return (
    <div
      style={{
        maxWidth: '28rem',
        margin: '80px auto',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, type: 'spring', bounce: 0.4 }}
        style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
      >
        <div style={{ fontSize: '3.75rem', color: '#ef4444' }}>
          <AlertTriangle
            style={{
              width: '4rem',
              height: '4rem',
              margin: '0 auto',
            }}
          />
        </div>
        <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#dc2626' }}>Oops! Something went wrong</h1>
        <p style={{ color: '#4b5563', lineHeight: '1.625' }}>
          We encountered an issue while generating your credentials. No worries, you can find your credentials on "API
          Subscription" page inside Pictory application.
          <br />
          If you need help, please contact support@pictory.ai.
        </p>
      </motion.div>

      <motion.div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          padding: '1.5rem',
          backgroundColor: '#fef2f2',
          borderRadius: '0.5rem',
          border: '1px solid #fecaca',
        }}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        <div style={{ fontSize: '0.875rem', color: '#b91c1c' }}>
          <p style={{ fontWeight: '500', marginBottom: '0.5rem' }}>Common causes:</p>
          <ul
            style={{ textAlign: 'left', marginLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.25rem' }}
          >
            <li>Network connectivity issues</li>
            <li>Server temporarily unavailable</li>
            <li>Rate limit exceeded</li>
          </ul>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.6 }}
        style={{
          textAlign: 'left',
          backgroundColor: '#f3f4f6', // gray-100
          padding: '1rem',
          borderRadius: '0.5rem',
          fontSize: '0.875rem',
          color: '#374151', // gray-700
          lineHeight: '1.5',
        }}
      >
        <CredentialInstructions />
      </motion.div>

      <motion.div
        style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9, duration: 0.5 }}
      >
        <Button
          size="large"
          target="_blank"
          href={process.env.REACT_APP_PICTORY_APP_URL}
          style={{
            backgroundColor: '#9333ea',
            color: '#fff',
            width: '100%',
            textTransform: 'none',
          }}
          onMouseOver={e => (e.currentTarget.style.backgroundColor = '#7e22ce')}
          onMouseOut={e => (e.currentTarget.style.backgroundColor = '#9333ea')}
        >
          Login
        </Button>
      </motion.div>
    </div>
  );
};

export default ErrorContent;
